import { PresetViews, UserPresetViewsApi } from '@bringg/dashboard-sdk';
import { getRootEnv } from '@bringg-frontend/bringg-web-infra';

import { ClientSideConfig } from './stores/types';
import { presetViewsStoreMapper } from './data-providers/preset-views-store-mapper';
import { groupFilters } from './consts';
import { PresetViewsViewStore } from './preset-views-view-store';

export class PresetViewsRootStore {
	presetViewStoreRepo: PresetViews<ClientSideConfig>;
	userPresetViewsStoreRepo: UserPresetViewsApi;
	presetViewsViewStore: PresetViewsViewStore;

	async init() {
		this.presetViewStoreRepo = getRootEnv().dashboardSdk.sdk.v2.createPresetViews<ClientSideConfig>(
			presetViewsStoreMapper.map,
			groupFilters
		);
		this.userPresetViewsStoreRepo = getRootEnv().dashboardSdk.sdk.v2.userPresetViews;
		this.presetViewsViewStore = new PresetViewsViewStore();

		await this.presetViewsViewStore.loadPresetsInfo();
	}
}
